export default {
  agreed: 'Zaakceptowano',
  searchStatement: 'Wyszukaj warunki korzystania z usługi',
  noData: 'Brak więcej danych',
  starts: 'Gwiazdka',
  searching: 'Wyszukiwanie',
  searchService: 'Wyszukaj warunki korzystania z usługi',
  filter: {
    performanceQuality: 'Jakość wykonania',
    comprehensiveExperienceScore: 'Ogólna ocena doświadczenia',
    fourStartDown: 'Poniżej czterech gwiazdek',
    certifiedFactory: 'Certyfikowana fabryka',
    dayYield: 'Wskaźnik wydajności 24h',
    doubleDayYield: 'Wskaźnik wydajności 48h',
    performanceGuarantee: 'Gwarancja wykonania',
    dayShipments: 'Wysyłka tego samego dnia',
    strictSelect: 'Rygorystyczna selekcja',
    disStrictSelect: 'Rygorystyczna selekcja dystrybucji',
    dayShip: 'Dostawa w 24h',
    doubleDayShip: 'Dostawa w 48h',
    sevenDayNoReason: 'Siedem dni bez podania przyczyny',
    oneIssuing: 'Wsparcie wysyłki pojedynczej sztuki',
    onePostIssuing:
      'Wsparcie darmowej wysyłki (Wysyłka pojedynczej sztuki jest darmowa)',
    sevenDayNew: '7 dni na nowe produkty',
    thirtyDayNew: '30 dni na nowe produkty',
    wordStrictSelect: 'Globalna rygorystyczna selekcja',
    isSelect: 'Wybrane palety transgraniczne',
    priceSort: 'Sortowanie według ceny',
    compositeSort: 'Sortowanie kompleksowe',
    up: 'Zwiń',
    reset: 'Resetuj',
    moreFilters: 'Więcej kryteriów filtrowania',
    bestMatch: 'Najlepsze dopasowanie',
    saleHighToLow: 'Sprzedaż: od najwyższej do najniższej',
    saleLowToHigh: 'Sprzedaż: od najniższej do najwyższej',
    priceHighToLow: 'Cena: od najwyższej do najniższej',
    priceLowToHigh: 'Cena: od najniższej do najwyższej',
    fastToSlow: 'Czas wysyłki: od najszybszego do najwolniejszego',
    slowToFast: 'Czas wysyłki: od najwolniejszego do najszybszego'
  }
};